import type { ExpressionSpecification } from 'mapbox-gl'

export const NODE_VISIBLE_MIN_ZOOM = 13.5

export const PLANNER_FALLBACK_ZOOM = 12

export const PLANNER_FIT_BOUNDS_PADDING = 64

export const PLANNER_FIT_BOUNDS_MAX_ZOOM = 14

export const PLANNER_FIT_BOUNDS_DURATION_MS = 800

export const NODE_LABEL_TEXT_SIZE: ExpressionSpecification = [
  'interpolate',
  ['linear'],
  ['zoom'],
  13.5,
  13,
  15,
  15,
  17,
  17,
]

export const NODE_LABEL_HALO_WIDTH = 3.5

export const NODE_LABEL_TEXT_ANCHOR = 'bottom' as const

export const NODE_LABEL_TEXT_OFFSET: [number, number] = [0, -0.35]

export const VIEWPORT_BUFFER_RATIO = 0.1

export const PLANNER_MAP_ID = 'route-planner-map'

export const DEFAULT_MIN_COVERED_RATIO = 0.95

export const CLEAR_MAP_OVERLAY_PROPS = { backgroundOpacity: 0, blur: 0 } as const

export const STREET_SEGMENTS_SOURCE = 'planner-street-segments'
export const STREET_SEGMENTS_LAYER = 'planner-street-segments-line'
export const STREET_SEGMENTS_ARROWS_LAYER = 'planner-street-segments-arrows'
export const STREET_ARROW_VISIBLE_MIN_ZOOM = 14
export const STREET_ARROW_ICON_SIZE = 0.5
export const STREET_ARROW_OPACITY = 0.5
export const PATH_SEGMENTS_SOURCE = 'planner-path-segments'
export const PATH_SEGMENTS_LAYER = 'planner-path-segments-line'
export const PATH_SEGMENTS_ARROWS_LAYER = 'planner-path-segments-arrows'
export const PATH_DIRECTION_ARROW_IMAGE_ID = 'plannerDirectionArrow'
export const PATH_ONE_WAY_ARROWS_FILTER: ExpressionSpecification = ['==', ['get', 'isBidirectional'], false]
export const CONTINUATION_SEGMENTS_SOURCE = 'planner-continuation-segments'
export const CONTINUATION_SEGMENTS_LAYER = 'planner-continuation-segments-line'
export const SHORTEST_PATH_SOURCE = 'planner-shortest-path'
export const SHORTEST_PATH_LAYER = 'planner-shortest-path-line'
export const PLANNER_STREET_COLOR = '#868e96'
export const PLANNER_PATH_COLOR = '#2f9e44'
export const PLANNER_CONTINUATION_COLOR = '#00b4ff'
export const PLANNER_CONTINUATION_STROKE = '#0077cc'
export const PLANNER_HINT_COLOR = '#fab005'
export const PLANNER_HINT_LINE_WIDTH = 4
export const PLANNER_HINT_DASHARRAY: [number, number] = [2, 1]
export const PLANNER_GAP_FIX_COLOR = '#fd7e14'
export const PLANNER_MUTED_COLOR = '#adb5bd'
export const PLANNER_START_NODE_COLOR = '#e03131'
export const PLANNER_START_NODE_STROKE = '#c92a2a'
export const PLANNER_NON_ROUTABLE_NODE_COLOR = '#adb5bd'
export const PLANNER_NON_ROUTABLE_NODE_STROKE = '#868e96'
export const PLANNER_NON_ROUTABLE_NODE_OPACITY = 0.55
export const NODES_SOURCE = 'planner-nodes'
export const NODES_LAYER = 'planner-nodes-circle'
export const NODES_HIT_LAYER = 'planner-nodes-hit'
export const NODES_LABEL_LAYER = 'planner-nodes-label'
export const START_NODE_RIPPLE_LAYER_A = 'planner-start-node-ripple-a'
export const START_NODE_RIPPLE_LAYER_B = 'planner-start-node-ripple-b'
export const END_NODE_RIPPLE_LAYER_A = 'planner-end-node-ripple-a'
export const END_NODE_RIPPLE_LAYER_B = 'planner-end-node-ripple-b'
export const FINISH_NODE_LAYER = 'planner-finish-node'
export const FINISH_NODE_IMAGE_ID = 'checkeredCircle'
export const PLANNER_END_NODE_COLOR = PLANNER_PATH_COLOR
export const PLANNER_END_NODE_STROKE = '#2b8a3e'
export const PLANNER_END_NODE_RIPPLE_COLOR = '#212529'
export const DISTINCT_FINISH_NODE_FILTER: ExpressionSpecification = [
  'all',
  ['boolean', ['get', 'isLastNode'], false],
  ['!', ['boolean', ['get', 'isStartNode'], false]],
]
export const NODE_HIT_PIXEL_PADDING = 4
export const AREA_POLYGON_SOURCE = 'planner-area-polygon'
export const AREA_POLYGON_FILL_LAYER = 'planner-area-polygon-fill'
export const AREA_POLYGON_LINE_LAYER = 'planner-area-polygon-line'
export const PARKING_POLYGONS_SOURCE = 'planner-parking-polygons'
export const PARKING_POLYGONS_FILL_LAYER = 'planner-parking-polygons-fill'
export const PARKING_POLYGONS_LINE_LAYER = 'planner-parking-polygons-line'
export const PLANNER_PARKING_FILL_COLOR = '#cd79f4'
export const PLANNER_PARKING_FILL_OPACITY = 0.77
export const PLANNER_PARKING_LINE_COLOR = 'rgba(212, 0, 255, 0.9)'
export const PLANNER_PARKING_LINE_WIDTH = 1
export const GAP_FIX_SOURCE = 'planner-gap-fix'
export const GAP_FIX_LAYER = 'planner-gap-fix-line'
export const REMOVAL_GAP_SEGMENT_ID = '__planner_removal_gap__'
export const EDIT_TAIL_SOURCE = 'planner-edit-tail'
export const EDIT_TAIL_LAYER = 'planner-edit-tail-line'
export const SIGN_POSTS_SOURCE = 'planner-sign-posts'
export const SIGN_POSTS_LAYER = 'planner-sign-posts-circle'
export const SIGN_POST_AZIMUTHS_SOURCE = 'planner-sign-post-azimuths'
export const SIGN_POST_AZIMUTHS_LAYER = 'planner-sign-post-azimuths-line'
export const SIGN_POST_VISIBLE_MIN_ZOOM = 14
export const SIGN_POST_AZIMUTH_VISIBLE_MIN_ZOOM = 15
export const SIGN_POST_ARROW_LENGTH_DEG = 0.00018
